import { h } from 'preact'

export default function option (label, value, selected) {
  return h('option', { value, selected }, label)
}
